import SectionHeading from "./SectionHeading";
import { testimonials } from "@/mocks/doujinData";

export default function About() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-100">
      <div className="container-x">
        <SectionHeading
          eyebrow="关于我们"
          title="为同人插画爱好者打造的高清图库"
          desc="我们专注于整理与展示优质同人画集、图包与高清原图，让收藏与参考变得更加轻松、愉悦。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="rounded-2xl overflow-hidden border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20artist%20drawing%20at%20a%20cozy%20desk%20with%20art%20prints%20and%20palettes%20around%2C%20warm%20creative%20studio%2C%20soft%20golden%20light%2C%20inspiring%20and%20comfortable%2C%20doujin%20art%20culture%2C%20high%20detail&width=1200&height=800&seq=doujin-about-01&orientation=landscape"
                alt="同人本子画集收藏与创作灵感"
                className="w-full aspect-[3/2] object-cover"
              />
            </div>
          </div>

          <div>
            <h3 className="font-heading text-xl md:text-2xl text-foreground-950">
              用心整理，只为更好的浏览体验
            </h3>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们相信，每一份同人创作都值得被认真对待。从高清画集的细致扫描，到成套图包的主题整理，再到原图的清晰呈现，我们持续打磨细节，让作品以最佳状态呈现在你面前。
            </p>

            <div className="mt-7 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                { icon: "ri-focus-3-line", title: "画质清晰", text: "细节丰富" },
                { icon: "ri-apps-2-line", title: "分类细致", text: "查找方便" },
                { icon: "ri-flashlight-line", title: "更新迅速", text: "新作不断" },
              ].map((feature) => (
                <div
                  key={feature.title}
                  className="rounded-xl bg-background-50 border border-background-200 p-5"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700 text-lg">
                    <i className={feature.icon}></i>
                  </span>
                  <p className="mt-3 font-heading text-base text-foreground-950">
                    {feature.title}
                  </p>
                  <p className="mt-1 text-sm text-foreground-600">{feature.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <figure
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200 p-6 md:p-7"
            >
              <div className="flex items-center gap-1 text-accent-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <blockquote className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                “{item.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-semibold">
                  {item.name.slice(0, 1)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}